import { configuratorService } from './configuratorService';

const getMembersFromMembers = member => {
  var results = [];
  if (!member) return results;
  let options = { firstMemberOnly: false, findByName: false };
  let description = '';
  if (!member.isGroup) {
    if (!description) return [member];

    if (options.findByName == true && description != member.name) return [];

    if (options.findByName !== true && description != member.description)
      return [];

    return [member];
  }

  for (let child of member.members) {
    if (child.isGroup) {
      results = results.concat(
        getMembersFromMembers(child, description, options)
      );
      continue;
    }

    if (
      !description ||
      (options.findByName == true && child.name == description) ||
      (options.findByName !== true && child.description == description)
    ) {
      results.push(child);
      continue;
    }
  }
  return results;
};

const getMembersFromRootMember = rootGroupMember => {
  let results = [];
  let description = '';
  let options = { firstMemberOnly: false, findByName: false };
  for (let member of rootGroupMember.members) {
    var memberResults = getMembersFromMembers(member, description, options);
    if (memberResults.length > 1 && options && options.firstMemberOnly == true)
      memberResults = [memberResults[0]];
    //memberResults[0].NodeName = this.NodeName;
    results = results.concat(memberResults);
  }
  return results;
};

const getCommitsFromMembers = member => {
  return getMembersFromMembers(member).filter(
    x => x.committed == true || x.alwaysCommitted == true
  );
};

const getCommitsFromRootMember = group => {
  return getMembersFromRootMember(group).filter(
    x => x.committed == true || x.alwaysCommitted == true
  );
};

const getMembersSelectionfromStepforManifoldAssembly = startData => {
  var selectedMembers = [];
  var rootMembers = [];
  var results = [];
  var result;
  var memberSelection = [];
  var steps;

  //Add Manifold Step
  result = {
    stepname: '',
    membersSelections: []
  };
  steps = startData.tactonModel.steps.filter(x => x.name.includes('manifold'));
  if (steps.length == 0) return [];
  rootMembers = steps[0].rootGroup.members.filter(x =>
    x.name.includes('ui_group')
  );
  for (let member of rootMembers) {
    selectedMembers = selectedMembers.concat(getMembersFromRootMember(member));
  }
  memberSelection = selectedMembers.map(x => {
    return {
      name: x.name,
      description: x.description,
      value: x.value,
      valueDescription: x.valueDescription
    };
  });
  result.stepname = steps[0].name;
  result.membersSelections = memberSelection;
  results = results.concat(result);
  //Add Segment Step
  result = {
    stepname: '',
    membersSelections: []
  };
  selectedMembers = [];
  steps = startData.tactonModel.steps.filter(x => x.name.includes('segment'));
  if (steps.length == 0) return [];
  var allStations = steps[0].rootGroup.members.filter(
    x => x.name.includes('segment') && x.hasVisibleParameters
  );

  for (let station of allStations) {
    //get segement series members
    var segmentUIMemberGroup = station.members.filter(
      x =>
        x.name.includes('ui_group') &&
        (!x.properties || x.properties['hidden'] != 'yes')
    );
    if (segmentUIMemberGroup.length > 0) {
      var seriesUIGroup = segmentUIMemberGroup[0].members.filter(
        x => !x.properties || x.properties['hidden'] != 'yes'
      )[0];
      selectedMembers.push(...getMembersFromMembers(seriesUIGroup));
    }
    //get selection members
    var segmentSelectionGroup = station.members.filter(
      x =>
        x.name.includes('selection') &&
        (!x.properties || x.properties['hidden'] != 'yes')
    );
    if (segmentSelectionGroup.length > 0)
      selectedMembers.push(...getMembersFromMembers(segmentSelectionGroup[0]));
  }
  memberSelection = selectedMembers.map(x => {
    return {
      name: x.name,
      description: x.description,
      value: x.value,
      valueDescription: x.valueDescription
    };
  });
  result.stepname = steps[0].name;
  result.membersSelections = memberSelection;
  results = results.concat(result);
  return results;
};

const getMembersSelectionfromStep = startData => {
  var results = [];
  var step = startData.tactonModel.steps.filter(x => x.current)[0];
  if (!step.hasOwnProperty('rootGroup')) return;
  var rootMembers = step.rootGroup.members.filter(x =>
    x.name.includes('division_group')
  );
  if (rootMembers.length == 0)
    rootMembers = step.rootGroup.members.filter(x =>
      x.name.includes('ui_group')
    );
  if (rootMembers.length == 0) rootMembers = step.rootGroup.members;
  for (let member of rootMembers) {
    results = results.concat(getMembersFromRootMember(member));
  }
  return results.map(x => {
    return { name: x.name, value: x.value };
  });
};

const getStep = startData => {
  if (startData != null) {
    if (
      startData?.isDynamicStackableProduct &&
      !(
        startData?.tactonModel?.steps?.filter(x =>
          x.name.includes('product_selection')
        ).length > 0
      )
    ) {
      if (
        startData?.tactonModel?.steps[1].name !=
        startData?.tactonModel?.steps?.filter(x => x.current)[0].name
      ) {
        return startData?.tactonModel?.steps[1];
      }
    } else if (startData.isManifoldProduct) {
      return startData.tactonModel.steps.filter(
        x => x.available == true && x.name.includes('segment')
      )[0];
    }

    return startData?.tactonModel?.steps?.filter(x => x.current)[0];
  }
};

const getMembersFromStepForStackables = async (startData, sessionData) => {
  var step = startData?.tactonModel.steps.filter(x => x.available);
  if (!step) return;

  var stepResult = [];
  var inputArr = [];
  var selectionArr = [];

  for (var i = 1; i < step.length - 1; i++) {
    var results = [];
    var inputObj = {};
    var selectionObj = {};

    let requestData = {
      divisionId: sessionData?.manufacturingDivision,
      productId: '',
      configState: startData?.configState,
      key: '',
      configModel: sessionData.configModel,
      step: step[i].name,
      tactonModel: startData?.tactonModel,
      IsPartSearchforDynamicStack: false
    };

    var stepData = await configuratorService(requestData);
    var availableSteps = stepData.tactonModel.steps.filter(
      x => x.name == step[i].name
    );
    if (step[i].name.includes('step_valve')) {
      var rootMembers = availableSteps[0].rootGroup.members.filter(x =>
        x.name.includes('ui_group')
      );

      for (let member of rootMembers) {
        results = results.concat(getMembersFromRootMember(member));
      }
      inputObj = {};
      selectionObj = {};
      inputObj['name'] = step[i].name;
      inputObj['values'] = results.filter(x => x.isParameter);
      selectionObj['name'] = step[i].name;
      selectionObj['description'] = step[i].description;
      selectionObj['values'] = results
        .filter(x => x.properties.hidden != 'yes')
        .map(x => {
          return {
            description: x.description,
            value: x.value,
            valueDescription: x.valueDescription,
            committed: x.committed
          };
        });
      inputArr.push(inputObj);
      selectionArr.push(selectionObj);
    } else {
      var rootMembers = availableSteps[0].rootGroup.members.filter(
        x => x.properties == undefined || x.name.includes('stud_kit')
      );
      for (var j = 0; j < rootMembers.length; j++) {
        results = [];
        results = results.concat(getMembersFromRootMember(rootMembers[j]));
        inputObj = {};
        selectionObj = {};
        inputObj['name'] = rootMembers[j].name;
        inputObj['values'] = results.filter(x => x.isParameter);
        selectionObj['name'] = rootMembers[j].name;
        selectionObj['description'] = rootMembers[j].description;
        selectionObj['values'] = results
          .filter(x => x.properties.hidden != 'yes')
          .map(x => {
            return {
              description: x.description,
              value: x.value,
              valueDescription: x.valueDescription,
              committed: x.committed
            };
          });
        inputArr.push(inputObj);
        selectionArr.push(selectionObj);
      }
    }
  }
  stepResult.push(inputArr);
  stepResult.push(selectionArr);
  return stepResult;
};

const getDivisionMembersFromStep = startData => {
  var results = [];
  var step = getStep(startData);
  if (!step.hasOwnProperty('rootGroup')) return;
  var rootMembers = step.rootGroup.members.filter(x =>
    x.name.includes('division_group')
  );
  if (rootMembers.length == 0)
    rootMembers = step.rootGroup.members.filter(x =>
      x.name.includes('ui_group')
    );
  if (rootMembers.length == 0) rootMembers = step.rootGroup.members;
  for (let member of rootMembers) {
    results = results.concat(getMembersFromRootMember(member));
  }

  return results.map(x => {
    return {
      name: x.description,
      value: x.value,
      valueDescription: x.valueDescription,
      domainName: x.domain.name,
      componentName: x.name,
      committed: x.committed,
      hidden: x.properties.hidden
    };
  });
};

const getMembersFromStepsforDynamicStackable = steps => {
  var results = [];

  for (let step of steps) {
    var result = {
      stepname: '',
      members: ''
    };
    var members = [];
    var rootMembers = step.rootGroup.members.filter(
      x => x.name.includes('ui_group') || x.name.includes('product_options')
    );
    if (rootMembers.length == 0) {
      //For Gold Cup
      var infoGroup = step.rootGroup.members.filter(
        x => x.properties && x.properties['info_group'] == 'yes'
      );
      rootMembers = step.rootGroup.members.filter(x => !infoGroup.includes(x));
    }
    for (let member of rootMembers) {
      members = members.concat(getMembersFromRootMember(member));
    }
    result.stepname = step.name;
    result.members = members;
    results = results.concat(result);
  }

  return results;
};

const getERPCode = startData => {
  var ERPCode;
  var step = getStep(startData);

  if (!step) return '';

  var partMem = step.rootGroup.members.filter(
    x => x.properties && x.properties['info_group'] == 'yes'
  );
  if (partMem.length > 0) {
    ERPCode = partMem[0].members.filter(
      x => x.properties['ph_erp_code'] == 'yes'
    );
  }
  if (ERPCode != undefined && ERPCode.length != 0) return ERPCode[0].value;
  return '';
};

const getOrderCodeComplete = startData => {
  var partNumber;
  var step = getStep(startData);

  if (!step) return '';
  var partMem = step.rootGroup.members.filter(
    x => x.properties && x.properties['info_group'] == 'yes'
  );
  if (partMem.length > 0) {
    partNumber = partMem[0].members.filter(
      x => x.properties && x.properties['ph_order_code_complete'] == 'yes'
    );
  }
  if (partNumber && partNumber.length > 0) return partNumber[0].value;
  return '';
};
const getOrderCodeLegacy = startData => {
  var partNumber;
  var step = getStep(startData);

  if (!step) return '';
  var partMem = step.rootGroup.members.filter(
    x => x.properties && x.properties['info_group'] == 'yes'
  );
  if (partMem.length > 0) {
    partNumber = partMem[0].members.filter(
      x => x.properties && x.properties['ph_order_code_legacy'] == 'yes'
    );
  }
  if (partNumber && partNumber.length > 0) return partNumber[0].value;
  return '';
};

const getPartNumberForNormalProduct = startData => {
  let partNumber;
  if (startData?.infoGroup?.partNumberValues?.length > 0) {
    partNumber = startData?.infoGroup?.partNumberValues?.filter(
      x => x.properties && x.properties['ph_use_code'] == 'yes'
    );
    if (partNumber.length == 0) {
      partNumber = startData?.infoGroup?.partNumberValues?.filter(
        x => x.properties && x.properties['ph_order_code_complete'] == 'yes'
      );
      if (partNumber.length == 0) {
        partNumber = startData?.infoGroup?.partNumberValues?.filter(
          x => x.properties && x.properties['ph_order_code_legacy'] == 'yes'
        );
      }
    }
  }
  if (partNumber != undefined && partNumber.length > 0)
    return partNumber[0].value;
  return '';
};

const getPartNumberString = startData => {
  var partNumber;
  var step = getStep(startData);
  if (!step) return '';
  if (!step.hasOwnProperty('rootGroup')) return '';

  var partMem = step?.rootGroup?.members?.filter(
    x => x.properties && x.properties['info_group'] == 'yes'
  );
  if (partMem.length > 0) {
    partNumber = partMem[0]?.members.filter(
      x =>
        x.properties['ph_use_code'] == 'yes' && x.properties['hidden'] != 'yes'
    );
    if (partNumber?.length == 0) {
      partNumber = partMem[0]?.members.filter(
        x => x.properties['ph_order_code_complete'] == 'yes'
      );
      if (partNumber.length == 0) {
        partNumber = partMem[0]?.members.filter(
          x => x.properties['ph_order_code_legacy'] == 'yes'
        );
      }
    }
  }
  if (partNumber && partNumber.length > 0) return partNumber[0].value;
  return '';
};

const getPartNumbers = step => {
  var partMember = step.rootGroup.members.filter(
    x => x.properties && x.properties['info_group'] == 'yes'
  );
  return partMember[0].members;
};

const getParts = startData => {
  let currentStep = getStep(startData);
  if (currentStep) {
    if (startData.isNormalProduct) {
      var currentAvailableStep = currentStep;
      if (startData.isManifoldProduct) {
        // to get the last available step assembly info group so that will have the proper number of segments in part number
        var avaialbleSteps = startData.tactonModel.steps.filter(
          x =>
            x.available == true &&
            x.name.includes('segment') &&
            x.hasOwnProperty('rootGroup')
        );
        var availableLength = avaialbleSteps.length;
        if (availableLength > 0) {
          currentAvailableStep = avaialbleSteps[availableLength - 1];
        }
      }

      var partInfoGroups = currentAvailableStep.rootGroup.members.filter(
        x => x.properties && x.properties['info_group'] == 'yes'
      );
      if (partInfoGroups.length > 0) {
        var partInfoGroup = partInfoGroups[0];
        return partInfoGroup.members.filter(
          x =>
            x.properties['ph_order_code_field'] == 'yes' &&
            x.properties['hidden'] == 'no'
        );
      }
    } else {
      return startData?.infoGroup?.partNumberValues;
    }
  }
};

const getStepMembers = startData => {
  let results = startData?.uiGroup?.members?.filter(
    x => x?.properties && x?.properties.hidden != 'yes'
  );

  if (startData.isManifoldProduct) {
    let segments = allSegments(startData);
    if (segments) {
      segments.map(workstation => {
        results = results.concat(
          currentSegmentSelectionMembers(workstation, startData)
        );
        results = results.concat(endSegment(workstation));
      });
      return results.filter(
        x => x?.properties && x?.properties.hidden != 'yes'
      );
    }
  }
  return results;
};

const allSegments = startData => {
  var allStations = startData?.segmentStep.rootGroup.members.filter(
    x =>
      x.name.includes('segment') &&
      x.name != 'segment_init' &&
      x.hasVisibleParameters
  );
  return allStations;
};

//get the current segment selection group from previous segment group
const currentSegmentSelectionGroup = (segment, response) => {
  //get the current segment group index
  var currentSegmentRootGroupIndex =
    response?.segmentStep.rootGroup.members.findIndex(x =>
      x.name.includes(segment.name)
    );
  //get selection group from prev segment group
  var prevSegmentRootGroup =
    response?.segmentStep.rootGroup.members[currentSegmentRootGroupIndex - 1];
  return prevSegmentRootGroup.members.filter(x => x.name.includes('selection'));
};
//get the current segment selection members from previous segment group
const currentSegmentSelectionMembers = (segment, response) => {
  var selectionMemberGroup = currentSegmentSelectionGroup(segment, response);
  //return current segment selection members
  return selectionMemberGroup[0].members.filter(
    x => !x.name.includes('add_segment')
  );
};

const endSegment = segment => {
  var nextSegmentSelectionMemberGroup = nextSegmentSelectionGroup(segment);
  var addAnotherSegmentMember =
    nextSegmentSelectionMemberGroup &&
    nextSegmentSelectionMemberGroup[0]?.members.filter(x =>
      x.name.includes('add_segment')
    );
  //if there is further more segments don't display this segments end of assembly controls
  if (
    addAnotherSegmentMember &&
    (addAnotherSegmentMember.length == 0 ||
      addAnotherSegmentMember[0]?.value == 'Yes')
  )
    return;
  return (
    nextSegmentSelectionMemberGroup &&
    nextSegmentSelectionMemberGroup[0]?.members.filter(
      x => !x.name.includes('add_segment')
    )
  );
};

const nextSegmentSelectionGroup = segment => {
  //next segment selection group
  return segment?.members.filter(x => x.name.includes('selection'));
};

const getNormalSteps = startData => {
  if (startData != null) {
    var steps = startData.tactonModel.steps;
    if (steps) {
      if (
        steps[0].name == 'initial_step' &&
        !startData.isDynamicStackableProduct
      ) {
        if (steps.length < 5) return [steps[1]];
      } else if (startData.isDynamicStackableProduct) {
        var summaryStep = steps.filter(
          x =>
            !x.name.includes('initial_step') &&
            !x.name.includes('product_selection') &&
            x.available == true
        );
        if (summaryStep.length > 0) {
          if (steps[0].name == 'product_selection' && steps.length > 2) {
            return [summaryStep[0]];
          } else {
            return [summaryStep];
          }
        } else return [];
      } else {
        if (steps.length < 5) return [steps[0]];
      }
    } else {
      return [];
    }
  }
};

export {
  getCommitsFromMembers,
  getMembersFromMembers,
  getMembersFromRootMember,
  getMembersSelectionfromStepforManifoldAssembly,
  getMembersSelectionfromStep,
  getMembersFromStepForStackables,
  getDivisionMembersFromStep,
  getMembersFromStepsforDynamicStackable,
  getERPCode,
  getOrderCodeComplete,
  getOrderCodeLegacy,
  getStep,
  getPartNumberForNormalProduct,
  getPartNumberString,
  getPartNumbers,
  getParts,
  getStepMembers,
  allSegments,
  getCommitsFromRootMember,
  getNormalSteps
};
